import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { FinnairOrder } from '@fcom/dapi/api/models';
import { BookingAndAppState } from '@fcom/common/interfaces/booking';
import { orderData } from '@fcom/common-booking';
import { ExpediaHotelOrigin, ThirdPartyAncillariesProvider } from '@fcom/common/enums';
import { CmsPageService } from '@fcom/common/services';
import { CmsImageData } from '@fcom/core-api';
import { ConfigService, NativeBridgeService, SentryLogger } from '@fcom/core';
import { getThirdPartyEligibility } from '@fcom/common-booking/utils/order.utils';
import { getCarTrawlerClientId } from '@fcom/common/utils/thirdparty.utils';

@Component({
  selector: 'fin-mmb-car-rental-route',
  templateUrl: './car-rental-route.component.html',
  styleUrls: ['../../../../common-booking/assets/helper-classes.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ManageBookingCarRentalRouteComponent implements OnInit {
  private router = inject(Router);
  private store$ = inject<Store<BookingAndAppState>>(Store);
  private pageService = inject(CmsPageService);
  private sentryLogger = inject(SentryLogger);
  private configService = inject(ConfigService);
  private nativeBridgeService = inject(NativeBridgeService);

  order$: Observable<FinnairOrder>;
  airportTransfersImage$: Observable<CmsImageData>;
  enableHotelsMMB: boolean;
  partnerEligibilities$: Observable<Partial<Record<ThirdPartyAncillariesProvider, boolean>>>;

  clientId: number;
  readonly ThirdPartyAncillariesProvider = ThirdPartyAncillariesProvider;
  readonly ExpediaHotelOrigin = ExpediaHotelOrigin;

  ngOnInit(): void {
    this.clientId = getCarTrawlerClientId('MMB_HOTELS_AND_CAR_RENTALS', this.nativeBridgeService.isInsideNativeWebView);
    this.enableHotelsMMB = this.configService.cfg.enableHotelsMMB;

    this.order$ = this.store$.pipe(orderData());
    this.airportTransfersImage$ = this.pageService.getPageData(this.router.url).pipe(
      map((template) => {
        if (!template.main?.[0]) {
          this.sentryLogger.error('Missing picture for airport transfers component in manage booking');
        }

        return template.main[0] as CmsImageData;
      })
    );

    this.partnerEligibilities$ = this.order$.pipe(
      map((order) => {
        return {
          [ThirdPartyAncillariesProvider.CAR_TRAWLER_RENTAL]: getThirdPartyEligibility(order, 'carRental'),
          [ThirdPartyAncillariesProvider.CAR_TRAWLER_TRANSFER]: getThirdPartyEligibility(order, 'airportTransfer'),
          [ThirdPartyAncillariesProvider.EXPEDIA_HOTEL]: getThirdPartyEligibility(order, 'hotel'),
        };
      })
    );
  }
}
